import { lazy, useEffect } from "react";
import PreviewReport from "../munaqasyah/pages/PreviewReport";
import SubBranchAdminClassesView from "../class/pages/SubBranchAdminClassesView";
// import BranchYearsView from "../academic/pages/BranchYearsView";
// import NewBranchYearsView from "../academic/pages/NewBranchYearView";
// import NewTeachingGroupView from "../teaching-group/page/NewTeachingGroupView";
import BranchAdminMunaqasyahView from "../munaqasyah/pages/BranchAdminMunaqasyahView";
import TeachingGroupDetailView from "../teaching-group/page/TeachingGroupDetailView";
import AddSubBranchToTeachingGroupView from "../teaching-group/page/AddSubBranchToTeachingGroupView";
import BranchAdminMunaqasyahDetailView from "../munaqasyah/pages/BranchAdminMunaqasyahDetailView";
import UpdateClassView from "../class/pages/UpdateClassView";
// import UpdateTeachingGroupView from "../teaching-group/page/UpdateTeachingGroupView";
import MunaqasyahClassList from "../munaqasyah/pages/MunaqasyahClassList";
import MunaqasyahByClassView from "../munaqasyah/pages/MunaqasyahByClassView";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { infoPortalRoutes } from "./infoPortalRoutes";

const DashboardNav = lazy(() =>
    import("../shared/Components/Navigation/DashboardNav/DashboardNav")
);
const DashboardView = lazy(() => import("../dashboard/pages/DashboardView"));
const StudentsView = lazy(() => import("../students/pages/StudentsView"));
const StudentDetailView = lazy(() =>
    import("../students/pages/StudentDetailView")
);
const TeachersView = lazy(() => import("../teachers/pages/TeachersView"));
const TeacherDetailView = lazy(() =>
    import("../teachers/pages/TeacherDetailView")
);
const NewTeacherView = lazy(() => import("../teachers/pages/NewTeacherView"));
const NewClassView = lazy(() => import("../class/pages/NewClassView"));
const ClassDetailView = lazy(() => import("../class/pages/ClassDetailView"));
const NewStudentView = lazy(() => import("../students/pages/NewStudentsView"));
const AddStudentToClassView = lazy(() =>
    import("../class/pages/AddStudentToClassView")
);
const AddTeacherToClassView = lazy(() =>
    import("../class/pages/AddTeacherToClassView")
);
const UpdateStudentView = lazy(() =>
    import("../students/pages/UpdateStudentView")
);
const UpdateTeacherView = lazy(() =>
    import("../teachers/pages/UpdateTeacherView")
);
const ProfileView = lazy(() => import("../users/pages/profile/ProfileView"));
const EmailVerifyView = lazy(() => import("../users/pages/auth/EmailVerifyView"));
// const BranchPerformanceView = lazy(() =>
//     import("../performance/pages/BranchPerformanceView")
// );
const RequestAccountView = lazy(() =>
    import("../users/pages/account-requests/RequestAccountView")
);
const RequestAccountForm = lazy(() =>
    import("../users/pages/account-requests/RequestAccountForm")
);
const RequestAccountTicketDetail = lazy(() =>
    import("../users/pages/account-requests/RequestAccountTicketDetail")
);
const HelpCenterView = lazy(() => import("../help-center/pages/HelpCenterView"));

const PerformanceRedirect = () => {
  useEffect(() => {
    window.location.href = "https://siakad.ppgcikampek.id/attendance-performance";
  }, []);
  return null;
};

const AcademicRedirect = () => {
  useEffect(() => {
    window.location.href = import.meta.env.VITE_ACADEMIC_BASE_URL + "/management/branch-academic-year";
  }, []);
  return null;
};

const StudentsRedirect = () => {
  useEffect(() => {
    window.location.href = import.meta.env.VITE_ACADEMIC_BASE_URL + "/students";
  }, []);
  return null;
};

const TeachersRedirect = () => {
  useEffect(() => {
    window.location.href = import.meta.env.VITE_ACADEMIC_BASE_URL + "/teachers";
  }, []);
  return null;
};

export const branchAdminRoutes = [
    { path: "/verify-email/:token", element: <EmailVerifyView /> },
    { path: "/profile/:userId", element: <ProfileView /> },
    { path: "/dashboard", element: <DashboardView /> },
    { path: "/help-center", element: <HelpCenterView /> },
    { path: "/dashboard/classes", element: <SubBranchAdminClassesView /> },
    { path: "/dashboard/classes/:classId", element: <ClassDetailView /> },
    { path: "/dashboard/classes/:classId/edit", element: <UpdateClassView /> },
    // { path: "/dashboard/students", element: <StudentsView /> },
    // { path: "/dashboard/students/new", element: <NewStudentView /> },
    // { path: "/dashboard/students/:studentId", element: <StudentDetailView /> },
    // {
    //     path: "/dashboard/students/:studentId/update",
    //     element: <UpdateStudentView />,
    // },
    { path: "/dashboard/students", element: <StudentsRedirect /> },
    { path: "/dashboard/students/new", element: <StudentsRedirect /> },
    { path: "/dashboard/students/:studentId", element: <StudentsRedirect /> },
    {
        path: "/dashboard/students/:studentId/update",
        element: <StudentsRedirect />,
    },
    { path: "/dashboard/teachers", element: <TeachersRedirect /> },
    { path: "/dashboard/teachers/new", element: <TeachersRedirect /> },
    { path: "/dashboard/teachers/:teacherId", element: <TeachersRedirect /> },
    { path: "/dashboard/teachers/:id/update", element: <TeachersRedirect /> },
    {
        path: "/dashboard/teaching-groups/:teachingGroupId",
        element: <TeachingGroupDetailView />,
    },
    {
        path: "/dashboard/teaching-groups/:teachingGroupId/add-class",
        element: <NewClassView />,
    },
    {
        path: "/dashboard/teaching-groups/:teachingGroupId/add-sub-branches",
        element: <AddSubBranchToTeachingGroupView />,
    },
    { path: "/munaqasyah/student/score", element: <PreviewReport /> },
    // { path: "/academic", element: <BranchYearsView /> },
    // { path: "/academic/new", element: <NewBranchYearsView /> },
    // { path: "/academic/teachingGroups/new", element: <NewTeachingGroupView /> },
    // { path: "/academic/teachingGroups/edit", element: <UpdateTeachingGroupView /> },
    { path: "/academic/*", element: <AcademicRedirect /> },
    { path: "/performance", element: <PerformanceRedirect /> },
    { path: "/settings/requestAccount", element: <RequestAccountView /> },
    {
        path: "/settings/requestAccount/:accountType",
        element: <RequestAccountForm />,
    },
    {
        path: "/settings/requestAccount/ticket/:ticketId",
        element: <RequestAccountTicketDetail />,
    },
    {
        path: "/dashboard/classes/:classId/add-students",
        element: <AddStudentToClassView />,
    },
    {
        path: "/dashboard/classes/:classId/add-teachers",
        element: <AddTeacherToClassView />,
    },
    // { path: '/performance', element: <SubBranchPerformanceView /> },
    { path: "/munaqasyah", element: <BranchAdminMunaqasyahView /> },
    {
        path: "/munaqasyah/:branchYearId",
        element: <BranchAdminMunaqasyahDetailView />,
    },
    {
        path: "/munaqasyah/:branchYearId/sub-branch/:subBranchId",
        element: <MunaqasyahClassList />,
    },
    {
        path: "/munaqasyah/:branchYearId/sub-branch/:subBranchId/class/:classId",
        element: (
            <QueryClientProvider client={new QueryClient()}>
                <MunaqasyahByClassView />
            </QueryClientProvider>
        ),
    },
    // Info Portal routes (accessible to all authenticated users)
    ...infoPortalRoutes,
];

export const BranchAdminRouteWrapper = ({ children }) => (
    <DashboardNav>{children}</DashboardNav>
);
